import { BoxIndicator } from '@classtinginc/design-system';
import { ElementType, useEffect } from 'react';
import { Route } from 'react-router-dom';

import { useBoolean } from 'react-use';

import useAuth from 'common/hooks/useAuth';
import { useWebViewBridge } from 'lib/web-view-bridge';

const PrivateRoute = ({
  component: Component,
  ...rest
}: {
  component: ElementType;
  path: string;
  exact?: boolean;
}) => {
  const { isClasstingRNWebView } = useWebViewBridge();
  const [isInitialized, setInitialized] = useBoolean(!isClasstingRNWebView());
  const { isAuthenticated, authorize } = useAuth();

  useEffect(() => {
    authorize();
  }, [authorize]);

  useEffect(() => {
    if (isClasstingRNWebView() && isAuthenticated) {
      setInitialized(true);
    }
  }, [isAuthenticated, isClasstingRNWebView, setInitialized]);

  if (!isInitialized) {
    return <BoxIndicator />;
  }

  return (
    <Route
      {...rest}
      render={(props: any) => {
        return isAuthenticated ? <Component {...props} /> : <BoxIndicator />;
      }}
    />
  );
};

export default PrivateRoute;
